import React, { Component } from 'react';

import cx from 'classnames';
import flattenedMediaModel from 'models/flattenedMediaModel';

import { Video, Button, Image } from 'components/base';

class IntroVideo extends Component {
  state = {
    videoIsEnded: false
  };

  handleVideoEnd = () => {
    this.setState({ videoIsEnded: true });
  };
  render() {
    const { introVideo } = this.props;

    return (
      <div
        className={cx('fixed w100 vh100 transition z1', {
          'opacity-0 events-none': this.state.videoIsEnded
        })}
      >
        <Video
          className="absolute vh100 w100 fit-cover"
          onEnded={this.handleVideoEnd}
          src={introVideo.url}
          autoPlay={true}
          loop={false}
        />
        <div className="IntroVideo__text-container absolute w100 b0 flex items-center justify-center">
          <div className="IntroVideo__inner-text-container relative w100 h100 image-width-extra-wide">
            <h2 className="IntroVideo__title absolute hero-title uppercase color-white text-width-medium text-center">
              Women Who Changed Science
            </h2>
            <div className="absolute b0 r0 m2">
              <Button
                ariaLabel="skip intro video"
                onClick={() => this.setState({ videoIsEnded: true })}
              >
                <span className="hero-description">Skip Intro</span>
                <Image
                  className="icon-width ml2_75"
                  alt="skip intro video"
                  src={`${
                    process.env.PUBLIC_URL
                  }/assets/images/icon-right-arrow.svg`}
                />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

IntroVideo.propTypes = {
  introVideo: flattenedMediaModel.propTypes
};

IntroVideo.defaultProps = {
  introVideo: flattenedMediaModel.default
};

export default IntroVideo;
